import { render, staticRenderFns } from "./WeekPicker.vue?vue&type=template&id=83761d16&scoped=true"
import script from "./WeekPicker.vue?vue&type=script&lang=js"
export * from "./WeekPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83761d16",
  null
  
)

export default component.exports